import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row } from "react-bootstrap";
import "./mega-menu.scss";
import Logo from "../../../../assets/website-images/utrust-logo.png";
import { FaEnvelope, FaLinkedinIn, FaPhone, FaLanguage } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./header.scss";
import { FiChevronDown, FiChevronUp } from "react-icons/fi"; // Import the arrows
import mega1 from "../../../../assets/website-images/mega/mega-1.png";
import mega2 from "../../../../assets/website-images/mega/mega-2.png";
import { motion } from "framer-motion";
import { AiFillInstagram, AiOutlineClose } from "react-icons/ai";
import { BsTwitterX } from "react-icons/bs";
import { MenuIcon } from "../../../../assets/web-icons/defaultWebIcons";
import { useDimensions } from "./useDimension"; // Import Framer Motion
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp
} from "react-icons/md";
import { useTranslation } from "react-i18next";

const sidebarVariants = {
  open: (height = 1000) => ({
    clipPath: `circle(${height * 2 + 200}px at 100% 0%)`, // Clip path starts from the top-right corner
    transition: {
      type: "spring",
      stiffness: 20,
      restDelta: 2
    }
  }),
  closed: {
    clipPath: "circle(0px at 100% 0%)", // Clip path collapses to a point at the top-right corner
    transition: {
      delay: 0.5,
      type: "spring",
      stiffness: 400,
      damping: 40
    }
  }
};

const MegaMenu = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menu, setMenu] = useState(false);
  const [ref, { height }] = useDimensions(); // Use the custom hook
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { t, i18n } = useTranslation();

  const changeLanguage = () => {
    const newLang =
      i18n.language === "en" || i18n.language === "en-US" ? "ar" : "en";
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    // Select the HTML tag
    const htmlTag = document.documentElement;

    // Set the font-family based on the language
    if (i18n.language === "ar") {
      htmlTag.style.fontFamily = "Cairo, sans-serif";
    } else {
      htmlTag.style.fontFamily = "Poppins, sans-serif";
    }
  }, [i18n.language]); // Run whenever the language changes

  useEffect(() => {
    // Toggle the body overflow when the menu state changes
    if (menu) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Clean up on component unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [menu]);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleMouseEnter = (menuIndex) => {
    setActiveMenu(menuIndex);
  };

  const handleMouseLeave = () => {
    setActiveMenu(null);
  };

  // Animation variants for Framer Motion
  const dropdownVariants = {
    hidden: { opacity: 0, height: 0 },
    visible: { opacity: 1, height: "auto" },
    exit: { opacity: 0, height: 0 }
  };

  return (
    <div>
      <header className={`header ${activeMenu ? "menu-open" : ""}`}>
        <Container>
          <Row>
            <Col md={12}>
              <div className={"menu-area"}>
                <div>
                  <Link to="/">
                    {" "}
                    <img className={"logo cp"} src={Logo} alt="Logo" />
                  </Link>
                </div>
                <div className={"menu"}>
                  <div className={"top-menu"}>
                    <ul className={"d-none d-md-flex"}>
                      <li dir={"ltr"}>
                        <span>
                          <FaPhone />
                        </span>{" "}
                        +966112699918
                      </li>
                      <li>
                        <span>
                          <FaEnvelope />
                        </span>{" "}
                        info@utrust.sa
                      </li>
                      <li className={"lang"}>
                        <span onClick={changeLanguage}>
                          {i18n.language === "en" ||
                          i18n.language === "en-US" ? (
                            <>
                              {" "}
                              <FaLanguage /> عربي
                            </>
                          ) : (
                            <>
                              <FaLanguage /> English
                            </>
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className={"main-menu"}>
                    <Nav className="justify-content-center mega-nav d-none d-md-flex">
                      <Nav.Item>
                        <Nav.Link
                          onMouseEnter={() => handleMouseEnter(1)}
                          onMouseLeave={handleMouseLeave}
                        >
                          {t("menu.products")}
                          {activeMenu === 1 ? (
                            <FiChevronUp className="ml-2" />
                          ) : (
                            <FiChevronDown className="ml-2" />
                          )}
                        </Nav.Link>

                        {activeMenu === 1 && (
                          <Nav.Link
                            onMouseEnter={() => handleMouseEnter(1)}
                            onMouseLeave={handleMouseLeave}
                            style={{
                              height: "0",
                              position: "absolute",
                              width: "100%",
                              left: "0"
                            }}
                          >
                            <motion.div
                              className="mega-dropdown"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={dropdownVariants}
                              onMouseEnter={() => handleMouseEnter(1)}
                              onMouseLeave={handleMouseLeave}
                            >
                              <Container>
                                <Row>
                                  <Col md={6}>
                                    <div className={"menu-list-box"}>
                                      <h5> {t("menu.products")}</h5>
                                      <ul className={""}>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/product">
                                            {t(
                                              "menu.product_megamenu.automated_biomatric"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/digital-identity">
                                            {t(
                                              "menu.product_megamenu.digital_identity"
                                            )}
                                          </Link>
                                        </li>
                                        {/*<li>*/}
                                        {/*    <Link to="/product">Identity Access Management</Link>*/}
                                        {/*</li>*/}
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/tochless-biomatric">
                                            {t(
                                              "menu.product_megamenu.touchless_biomatric"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/biomatric-sdks">
                                            {t(
                                              "menu.product_megamenu.biomatric_sdk"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/utrust-surveillance">
                                            {t(
                                              "menu.product_megamenu.utrust_surveillance"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/id-solutions">
                                            {t(
                                              "menu.product_megamenu.id_solutions"
                                            )}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <img src={mega1} className={"img-fluid"} />
                                  </Col>
                                </Row>
                              </Container>
                            </motion.div>
                          </Nav.Link>
                        )}
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          onMouseEnter={() => handleMouseEnter(2)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <Link
                            to="/services"
                            onClick={() => {
                              handleMouseLeave();
                            }}
                          >
                            {" "}
                            {t("menu.services")}
                          </Link>

                          {activeMenu === 2 ? (
                            <FiChevronUp className="ml-2" />
                          ) : (
                            <FiChevronDown className="ml-2" />
                          )}
                        </Nav.Link>

                        {activeMenu === 2 && (
                          <Nav.Link
                            onMouseEnter={() => handleMouseEnter(2)}
                            onMouseLeave={handleMouseLeave}
                            style={{
                              height: "0",
                              position: "absolute",
                              width: "100%",
                              left: "0"
                            }}
                          >
                            <motion.div
                              className="mega-dropdown"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={dropdownVariants}
                              onMouseEnter={() => handleMouseEnter(2)}
                              onMouseLeave={handleMouseLeave}
                            >
                              <Container>
                                <Row>
                                  <Col md={6}>
                                    <div className={"menu-list-box"}>
                                      <h5>{t("menu.services")}</h5>
                                      <ul className={""}>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/utrust-surveillance">
                                            {t(
                                              "menu.service_megamenu.utrust_surveillance"
                                            )}{" "}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/id-programs-service">
                                            {t(
                                              "menu.service_megamenu.id_programs"
                                            )}{" "}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/forensic-bio-service">
                                            {t(
                                              "menu.service_megamenu.forensic_bio"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/biometric-sdk-service">
                                            {t(
                                              "menu.service_megamenu.biomatric_sdk"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/biometric-driven-emergency-service">
                                            {t(
                                              "menu.service_megamenu.biometric_driven"
                                            )}{" "}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/custom-id-service">
                                            {t(
                                              "menu.service_megamenu.custom_iam"
                                            )}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/services/premise-biometric-service">
                                            {t(
                                              "menu.service_megamenu.on_premise"
                                            )}
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                  <Col md={6} className={"text-center"}>
                                    <img src={mega2} className={"img-fluid"} />
                                  </Col>
                                </Row>
                              </Container>
                            </motion.div>
                          </Nav.Link>
                        )}
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link>
                          <Link to="/clients">{t("menu.clients")}</Link>
                        </Nav.Link>
                      </Nav.Item>

                      {/*<Nav.Item>*/}
                      {/*    <Nav.Link>*/}
                      {/*        <Link to="/about">About Us</Link>*/}
                      {/*    </Nav.Link>*/}
                      {/*</Nav.Item>*/}

                      <Nav.Item>
                        <Nav.Link
                          onMouseEnter={() => handleMouseEnter(3)}
                          onMouseLeave={handleMouseLeave}
                        >
                          {t("menu.about_us")}
                          {activeMenu === 3 ? (
                            <FiChevronUp className="ml-2" />
                          ) : (
                            <FiChevronDown className="ml-2" />
                          )}
                        </Nav.Link>

                        {activeMenu === 3 && (
                          <Nav.Link
                            onMouseEnter={() => handleMouseEnter(3)}
                            onMouseLeave={handleMouseLeave}
                            style={{
                              height: "0",
                              position: "absolute",
                              width: "100%",
                              left: "0"
                            }}
                          >
                            <motion.div
                              className="mega-dropdown"
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              variants={dropdownVariants}
                              onMouseEnter={() => handleMouseEnter(3)}
                              onMouseLeave={handleMouseLeave}
                            >
                              <Container>
                                <Row>
                                  <Col md={6}>
                                    <div className={"menu-list-box"}>
                                      <h5> {t("menu.about_us")}</h5>
                                      <ul className={""}>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/about">
                                            {" "}
                                            {t("menu.about")}{" "}
                                          </Link>
                                        </li>
                                        <li
                                          onClick={() => {
                                            handleMouseLeave();
                                          }}
                                        >
                                          <Link to="/contact">
                                            {" "}
                                            {t("menu.contact")}{" "}
                                          </Link>
                                        </li>
                                        {/*<li onClick={()=>{handleMouseLeave()}}>*/}
                                        {/*    <Link to="#">Careers</Link>*/}
                                        {/*</li>*/}
                                      </ul>
                                    </div>
                                  </Col>
                                  <Col md={6} className={"text-center"}>
                                    <img src={mega2} className={"img-fluid"} />
                                  </Col>
                                </Row>
                              </Container>
                            </motion.div>
                          </Nav.Link>
                        )}
                      </Nav.Item>
                    </Nav>
                    <div className={"options d-flex d-md-none"}>
                      {/*<span><RiSearchLine /></span>*/}
                      <span onClick={() => setMenu(!menu)}>
                        <MenuIcon />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </header>
      <motion.div
        className={"big-menu"}
        initial={false}
        animate={menu ? "open" : "closed"}
        variants={sidebarVariants}
        custom={height}
        ref={ref}
      >
        <Container>
          <Row>
            <Col md={12}>
              <div className={"menu-header"}>
                <div>
                  <img className={"logo"} src={Logo} alt="Logo" />
                </div>
                <div>
                  <span onClick={() => setMenu(false)} className={"close-icon"}>
                    <AiOutlineClose />
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className={"menu-content"}>
                <div className={"menu-list"}>
                  <ul>
                    <li className={"lang"}>
                      <span
                        style={{ fontSize: "30px" }}
                        onClick={changeLanguage}
                      >
                        {i18n.language === "en" || i18n.language === "en-US" ? (
                          <>
                            {" "}
                            <FaLanguage /> عربي
                          </>
                        ) : (
                          <>
                            <FaLanguage /> English
                          </>
                        )}
                      </span>
                    </li>
                    <li>
                      <div
                        onClick={() => toggleDropdown("products")}
                        className={`dropdown-header ${
                          activeDropdown === "products" ? "active" : ""
                        }`}
                      >
                        <Link to="#">{t("menu.products")}</Link>
                        <span className="dropdown-icon">
                          {activeDropdown === "products" ? (
                            <MdOutlineKeyboardArrowUp />
                          ) : (
                            <MdOutlineKeyboardArrowDown />
                          )}
                        </span>
                      </div>
                      {activeDropdown === "products" && (
                        <ul>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/product">
                              {t("menu.product_megamenu.automated_biomatric")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/digital-identity">
                              {t("menu.product_megamenu.digital_identity")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/tochless-biomatric">
                              {t("menu.product_megamenu.touchless_biomatric")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/biomatric-sdks">
                              {t("menu.product_megamenu.biomatric_sdk")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/utrust-surveillance">
                              {t("menu.product_megamenu.utrust_surveillance")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/id-solutions">
                              {t("menu.product_megamenu.id_solutions")}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li>
                      <div
                        onClick={() => toggleDropdown("services")}
                        className={`dropdown-header ${
                          activeDropdown === "services" ? "active" : ""
                        }`}
                      >
                        <Link to="#">{t("menu.services")}</Link>
                        <span className="dropdown-icon">
                          {activeDropdown === "services" ? (
                            <MdOutlineKeyboardArrowUp />
                          ) : (
                            <MdOutlineKeyboardArrowDown />
                          )}
                        </span>
                      </div>
                      {activeDropdown === "services" && (
                        <ul>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/utrust-surveillance">
                              {t("menu.service_megamenu.utrust_surveillance")}{" "}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/id-programs-service">
                              {t("menu.service_megamenu.id_programs")}{" "}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/forensic-bio-service">
                              {t("menu.service_megamenu.forensic_bio")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/biometric-sdk-service">
                              {t("menu.service_megamenu.biomatric_sdk")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/biometric-driven-emergency-service">
                              {t("menu.service_megamenu.biometric_driven")}{" "}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/custom-id-service">
                              {t("menu.service_megamenu.custom_iam")}
                            </Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/services/premise-biometric-service">
                              {t("menu.service_megamenu.on_premise")}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li onClick={() => setMenu(false)}>
                      <Link to="/clients">{t("menu.clients")}</Link>
                    </li>

                    <li>
                      <div
                        onClick={() => toggleDropdown("about")}
                        className={`dropdown-header ${
                          activeDropdown === "about" ? "active" : ""
                        }`}
                      >
                        <Link to="#">{t("menu.about_us")}</Link>
                        <span className="dropdown-icon">
                          {activeDropdown === "about" ? (
                            <MdOutlineKeyboardArrowUp />
                          ) : (
                            <MdOutlineKeyboardArrowDown />
                          )}
                        </span>
                      </div>
                      {activeDropdown === "about" && (
                        <ul>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/about">{t("menu.about")}</Link>
                          </li>
                          <li onClick={() => setMenu(false)}>
                            <Link to="/contact">{t("menu.contact")}</Link>
                          </li>
                          {/*<li onClick={() => setMenu(false)}>*/}
                          {/*    <Link to="#">Careers</Link>*/}
                          {/*</li>*/}
                        </ul>
                      )}
                    </li>
                  </ul>
                </div>

                <div className={"social-list"}>
                  <ul>
                    <li>
                      <h4>{t("email")}</h4>
                      <p>info@utrust.sa</p>
                    </li>
                    <li>
                      <h4>{t("phone")}</h4>
                      <p dir="ltr">{t("phone_number")}</p>
                    </li>
                    <li>
                      <h4>{t("address")}</h4>
                      <p>{t("address_text")}</p>
                    </li>
                    <li>
                      <h4>{t("social_media")}</h4>
                      <div className={"social-icons mt-3"}>
                        <span>
                          <a
                            className={"text-white"}
                            href="https://www.instagram.com/utrustsa?igsh=MTQ0d2N4Nms1NTdoNg=="
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <AiFillInstagram className="text-pink-500 text-3xl" />
                          </a>
                        </span>
                        <span>
                          <a
                            className={"text-white"}
                            href="https://x.com/utrustsa?s=21"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <BsTwitterX className="text-blue-500 text-3xl" />
                          </a>
                        </span>
                        <span>
                          <a
                            className={"text-white"}
                            href="https://www.linkedin.com/company/utrustsa/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaLinkedinIn className="text-blue-700 text-3xl" />
                          </a>
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </motion.div>
    </div>
  );
};

export default MegaMenu;
